import { FormControl, FormGroup } from '@angular/forms';
import { ConnectionInterface } from '@vendasta/ai-assistants';
import { AiConnection, CTAction } from '../interfaces/ai-assistant.interface';
import { FormArrayWithDirtyTracking } from './forms';

export interface ConnectionMetadata {
  id: string;
  name: string;
  iconUrl: string;
  isDefault: boolean;
  cta?: CTAction;
  hasOtherConnections: boolean;
}

// Connections
interface ConnectionFormControls {
  connected: FormControl<boolean | null>;
}

export class ConnectionForm extends FormGroup<ConnectionFormControls> {
  constructor(
    public readonly metadata: ConnectionMetadata,
    connected: boolean,
    disabled: boolean,
  ) {
    super({
      connected: new FormControl({ value: connected, disabled }),
    });
  }
}

export class AiConnectionsForm extends FormArrayWithDirtyTracking<ConnectionForm> {
  constructor(aiConnections: AiConnection[], assistantId: string) {
    const connectionForms = aiConnections
      .map((aiConnection) => {
        if (!aiConnection?.connection?.id) {
          return null;
        }

        const hasOtherConnections =
          aiConnection.connection.assistantKeys?.some((assistantKey) => assistantKey.id !== assistantId) || false;

        const metadata: ConnectionMetadata = {
          id: aiConnection.connection.id,
          name: aiConnection.connection.name || '',
          iconUrl: aiConnection.connection.iconUrl || '',
          isDefault: aiConnection.isDefault || false,
          cta: aiConnection.cta,
          hasOtherConnections,
        };

        const connected =
          aiConnection.connection.assistantKeys?.some((assistantKey) => assistantKey.id === assistantId) || false;

        const disabled = aiConnection.connection.isConnectionLocked || aiConnection.isDefault || false;

        return new ConnectionForm(metadata, connected, disabled);
      })
      .filter((form): form is ConnectionForm => form !== null);

    super(connectionForms);
  }

  toConnections(): ConnectionInterface[] {
    return this.controls.map((connectionForm) => {
      const connection = connectionForm.metadata;

      return {
        id: connection.id,
        name: connection.name,
        iconUrl: connection.iconUrl,
        favourite: connection.isDefault,
      };
    });
  }
}
